import request from '@/utils/request'

/**
 * 获取所有省份
 * @param {} data
 */
// export const path = '/sc-operating-center/p-api/v1'
export const path = '/ms-main-operating/p-api/v1'
export const loginPath = 'ms.api.yunsoho.cn/fss-auth/p-api/v1/'

//  let path=''
//  if(process.env.VUE_APP_MODE==='development'){
//   //开发环境下的执行操作
//   path='/ims-operating'
// }else if(process.env.VUE_APP_MODE==='production'){
//   //生产环境下的执行操作
//   path='/ims-operating-provider/p-api/v1'
// }
export function getProvinceList(data) {
  return request({
    url: path + '/city/all-provinces',
    method: 'get',
    data
  })
}
export function getAllProvinceList() {
  return request({
    url: path + '/city/provinces',
    method: 'get'
    
  })
}
/**
 * 根据省份Id获取城市
 * @param {provinceId} data
 */
export function getCityList(provinceId) {
  return request({
    url: path + `/city/citys/${provinceId}`,
    method: 'get'
   
  })
}
/**sys-city/save */
export function saveOperateCity(data) {
  return request({
    url: path + '/sys-city/save',
    method: 'post',
    data
  })
}

/**保存编辑后的系统运营城市t */
export function saveEditOperateCity(data) {
  return request({
    url: path + '/sys-city/save/edit',
    method: 'post',
    data
  })
}
/**
 * 获取所有运营城市
 * @param {}
 */
export function getOperateCityList() {
  return request({
    url: path + '/sys-city/page',
    method: 'get'
  })
}
/**
 * 
 * @param {*} data 
 * @returns 
 */
export function switchStatusOperateCity(data) {
  return request({
    url: path + '/sys-city/switch-status',
    method: 'post',
    data
  })
}
/**
 * 根据城市编码获取所有运营区域
 * @param {} cityCode
 */
export function getCityDistrictsList(cityCode) {
  return request({
    url: path + '/city/districts/' + cityCode,
    method: 'get'
  })
}
/**sys-city/save */
export function saveOperateArea(data) {
  return request({
    url: path + '/sys-area/save',
    method: 'post',
    data
  })
}
/**
 * 获取所有系统运营区域分页列表
 * sys-area/page
 */
export function getOperateAreaPage(params) {
  return request({
    url: path + '/sys-area/page',
    method: 'get',
    params
  })
}
/**
 * sys-area/switch-status
 */
export function switchStatusOperateArea(data) {
  return request({
    url: path + '/sys-area/switch-status',
    method: 'post',
    data
  })
}
/**
 * 根据运营城市编码获取所有运营区域
 * @param {} cityCode
 */
export function getOperateCityAreaList(cityCode) {
  return request({
    url: path + '/city/areas/' + cityCode,
    method: 'get'
  })
}

/**
 * 根据运营城市获取所有区域
 * @param {} cityId
 */
export function getAllArea(cityId) {
  return request({
    url: path + `/city/district-list/${cityId}`,
    method: 'get'
  })
}

/**
 * 根据区域获取道路
 * @param {} areaCode
 */
export function getOperateAreaRoadList(areaCode) {
  return request({
    url: path + '/city/roads/' + areaCode,
    method: 'get'
  })
}

/**
 * 根据道路获取路段
 * @param {} areaCode
 */
export function getOperateRoadSectionsList(roadId) {
  return request({
    url: path + '/city/road-sections/' + roadId,
    method: 'get'
  })
}

/**
 * 根据区域获取停车场
 * @param {} areaCode
 */
export function byAreaCodeGetParkingLotList(roadId) {
  return request({
    url: path + '/city/parks/' + roadId,
    method: 'get'
  })
}

//
/**
 * 根据区域编码获取街道办信息
 * @param {} areaCode
 */
export function byAreaCodeGetSubdistrictOfficeList(areaCode) {
  return request({
    url: path + `/city/stricts/${areaCode}`,
    method: 'get'
  })
}

/**
 * 文件上传
 * @param {} data
 */
export function sendUploadFile(data) {
  return request({
    url: path + '/common/upload-file',
    method: 'post',
    data
  })
}

/**
 * 
 * dict-type/add-dict-type */
export function addDictType(data) {
  return request({
    url: path + `/dict-type/add-dict-type`,
    method: 'post',
    data
  })
}
export function editDictType(data) {
  return request({
    url: path + `/dict-type/edit-dict-type`,
    method: 'post',
    data
  })
}
/**
 * 
 * @param {*} id 
 * @returns 
 */
export function getParentDictTypeList() {
  return request({
    url: path + `/dict-type/get-dict-type`,
    method: 'get'
  })
}
export function getParentDictTypePages() {
  return request({
    url: path + `/dict-type/get-dict-type-info`,
    method: 'get'
  })
}
export function getEnableParentDictTypePages() {
  return request({
    url: path + `/dict-type/get-enable-dict-type`,
    method: 'get'
  })
}

export function refreshParentDictType(typeMark) {
  return request({
    url: path + `/dict-type//refresh/${typeMark}`,
    method: 'post'
  })
}

export function switchParentDictType(data) {
  return request({
    url: path + `/dict-type/switch-status`,
    method: 'post',
    data
  })
}

/**dictionary/add-dictionary */

export function getChildrenDictTypePages(params) {
  return request({
    url: path + `/dictionary/get-dictionary-info`,
    method: 'get',
    params
  })
}


export function addChildrenDictionary(data) {
  return request({
    url: path + `/dictionary/add-dictionary`,
    method: 'post',
    data
  })
}
export function editChildrenDictionary(data) {
  return request({
    url: path + `/dictionary/edit-dictionary`,
    method: 'post',
    data
  })
}

export function switchChildrenDictType(data) {
  return request({
    url: path + `/dictionary/edit-status`,
    method: 'post',
    data
  })
}
/**
 * 通用字典
 * 获取子字典类型
 */
export function getChildCategory(id) {
  return request({
    url: path + `/dictionary/get-dictionary/${id}`,
    method: 'get'
  })
}

/**
 * 数据字典
 * 根据父类唯一标识获取子类型分类
 */
export function getChildCategoryByTypeMark(typeMark) {
  return request({
    url: path + `/dictionary/get-dictionary/type-mark/${typeMark}`,
    method: 'get'
  })
}

/**
 更改系统用户登录状态
 */
 export function sysUserChangeLoginStatus(data) {
  return request({
    url: path + '/sys-user/change-login-status',
    method: 'post',
    data
  })
}

// 获取当前城市全部启用的产权归属方
export function getAttributionManage(cityCode) {
  return request({
    url: path + "/attribution-manage/get/" + cityCode,
    method: "get"
  });
}


/**
 * 获取停车场
 * @param {} cityCode
 */
 export function getPricePlateParkingList(params) {
  return request({
    url: path + '/parking-price-plate/get-park-list',
    method: 'get',
    params
  })
}
// 登录判断是否可以进入对应平台
export function loginJudge(platform) {
  return request({
    url: path + `/user/manger/login/judge/${platform}`,
    method: "get"
  });
}

/**
 * 系统用户解锁
 */
export function unlockSysuser(userId) {
  return request({
      url:`/fss-auth/p-api/v1/admin-users/unlock/${userId}`,
      method: 'post',

  })
}
//更新
export function adminUsers(id,data) {
  return request({
      url:`/fss-auth/p-api/v1/admin-users/${id}`,
      method: 'post',
      data,
  })
}
/**
 * 获取配置页面树
 */
export function getMenuTree(params) {
  return request({
      // url:path+ '/sys-menu-personal/get-menu-tree',
      url: path +'/sys-user/get-menu-tree', // TODO 权限
      method: 'get',
      params: { ...params, menuName: "" }

  })
}

/***
 * 
 */
export function getAdminRoles() {
  return request({
    url: path+`/sys-user/get-admin-roles`,
    method: "get",
    
  });

}


export function getStoreUserAdminRoles() {
  return request({
    url: path+`/store-sys-user/get-admin-roles`,
    method: "get",
    
  });
}

export function currentSysUserInfo() {
  return request({
    url: path+`/sys-user/current-sys-user-info`,
    method: "get",
  });
}
